const Footer = () => {
	return (
		<footer className="bg-white border-t text-center text-sm py-3 text-gray-500">
			Design & Developed by{" "}
			<span className="text-blue-500">VRSamadhan Tech Solution</span>
		</footer>
	);
};

export default Footer;
